import * as z from "zod";
import { dateSchema, requiredString } from "components/form/utils";

export const holidaySchema = z.object({
  name: requiredString(),
  date: dateSchema,
});
